<template>
  <section>
    <div v-if="checkedRows && checkedRows.length > 0" class="box is-flex is-flex-direction-row">
      <div class="mr-auto is-size-6 has-text-weight-bold">{{ checkedRows.length }} selected</div>
      <div class="mt-auto mb-auto ml-auto mr-auto">
        <b-select expanded style="min-width: 300px" placeholder="Select event status" size="is-small"
                  v-model="selectedStatusChange">
          <option v-for="key in Object.keys(validationOptions)" :value="key" :key="key">{{ validationOptions[key] }}
          </option>
        </b-select>
      </div>
      <div class="mt-auto mb-auto ml-auto">
        <b-button size="is-small" @click="onUpdateSelectedItems" type="is-primary" :disabled="!selectedStatusChange"
                  icon-left="content-save">Update Selected Status
        </b-button>
      </div>
    </div>
    <div class="box p-4 mb-1">
      <div class="is-flex">
        <div v-if="selectedDevice && selectedDevice.dataVersions" class="ml-1 is-flex is-flex-direction-row">
          <b-select v-model="dataVersion" size="is-small" @input="onVersionChanged" class="mt-auto mb-auto">
            <option v-for="version of this.selectedDevice.dataVersions" :value="version" :key="version">{{ version }}
            </option>
          </b-select>
          <b-taglist attached class="m-0 p-0 ml-3 mt-2 mb-auto">
            <b-tag type="is-dark">Version</b-tag>
            <b-tag type="is-info">
              {{ dataVersion }}
            </b-tag>
          </b-taglist>
        </div>

        <b-select v-model="perPage" class="ml-auto" size="is-small">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
        </b-select>
      </div>

      <b-table
          v-if="validationTableData"
          key="incident_table"
          ref="table"
          :data="validationTableData"
          :checked-rows.sync="checkedRows"
          checkable
          checkbox-position="left"
          checkbox-type="is-primary"
          hoverable
          paginated
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="false"
          pagination-position="bottom"
          pagination-size="is-small"
          default-sort-direction="asc"
          :pagination-rounded="false"
          sort-icon="arrow-up"
          sort-icon-size="is-small"
          @sort="sortClicked"
          default-sort="user.first_name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          @page-change="onPageChanged"
          :page-input="false">
        <b-table-column field="eventId" label="ID">
          <template v-slot:header="{ column }">
            <table-header :column="column" element-id="223423" header-type="none"
                          :table-header-data="tableHeaderData" @onSort="onSort">
            </table-header>
          </template>
          <template v-slot="props">
            <b-button style="max-height: 24px" type="is-ghost"
                      :disabled="selectedEvent && selectedEvent.id === props.row.id"
                      @contextmenu.prevent="copyToClipboard(props.row.id)"
                      @click="loadEvent(props.row)">{{cropId(props.row.id, 3, 3)}}
            </b-button>
          </template>
        </b-table-column>
        <b-table-column field="eventValid" label="Event Valid">
          <template v-slot:header="{ column }">
            <!--            <table-header :column="column" header-type="search" tooltip="Filter Event Valid" element-id="4665986886"
                                      :table-header-data="tableHeaderData" @onSort="onSort"></table-header>-->

            <table-header :column="column" header-type="dropdown"
                          element-id="2234228687576"
                          :options="['unchecked', 'validated', 'incorrect', 'correct', 'invalid']"
                          tooltip="Filter event valid"
                          :table-header-data="tableHeaderData"
                          @onSort="onSort"
            ></table-header>

          </template>
          <template v-slot="props">

            <b-tag :type="getClass(props.row.eventValid)" style="min-width: 80px">{{ props.row.eventValid }}</b-tag>

          </template>
        </b-table-column>
        <b-table-column field="eventAt" label="Event Start" sortable>
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="date" tooltip="Filter Event Start" element-id="254788453"
                          :table-header-data="tableHeaderData" @onSort="onSort">
            </table-header>
          </template>
          <template v-slot="props">
            {{ getTime(props.row.eventAt) }}
          </template>
        </b-table-column>
<!--        <b-table-column field="eventEnd" label="Event End" sortable>
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="date" tooltip="Filter Event End Time"
                          element-id="25478433388453"
                          :table-header-data="tableHeaderData" @onSort="onSort">
            </table-header>
          </template>
          <template v-slot="props">
            {{ props.eventEnd ? getTime(props.row.eventEnd) : 'Undefined' }}
          </template>
        </b-table-column>-->
        <b-table-column field="severityRating" label="Risk">
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="search" tooltip="Filter Risk" element-id="46744346576"
                          :table-header-data="tableHeaderData" @onSort="onSort"></table-header>
          </template>
          <template v-slot="props">
            {{ props.row.severityRating }}
          </template>
        </b-table-column>
<!--        <b-table-column field="coreIndicators" label="Core Indicators">
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="dropdown"
                          element-id="223400087576"
                          :options="Object.keys(coreIndicatorsOptions)"
                          tooltip="Filter event valid"
                          :table-header-data="tableHeaderData"
                          @onSort="onSort"
            ></table-header>
          </template>
          <template v-slot="props">
            {{ props.row.coreIndicators.toString() }}
          </template>
        </b-table-column>-->
        <!--        <b-table-column field="eventClass" label="Event Class">
                  <template v-slot:header="{ column }">
                    <table-header :column="column" header-type="search" tooltip="Filter Event Class" element-id="4674434"
                                  :table-header-data="tableHeaderData" @onSort="onSort"></table-header>
                  </template>
                  <template v-slot="props">
                    {{ props.row.eventClass }}
                  </template>
                </b-table-column>
                <b-table-column field="eventType" label="Event Type">
                  <template v-slot:header="{ column }">
                    <table-header :column="column" header-type="search" tooltip="Filter Event Type" element-id="46744344645645"
                                  :table-header-data="tableHeaderData" @onSort="onSort"></table-header>
                  </template>
                  <template v-slot="props">
                    {{ props.row.eventType }}
                  </template>
                </b-table-column>-->
<!--        <b-table-column field="petValue" label="Pet">
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="search" tooltip="Filter Pet (max)" element-id="4665986884336"
                          :table-header-data="tableHeaderData" @onSort="onSort"></table-header>
          </template>
          <template v-slot="props">
            {{ props.row.petValue }}
          </template>
        </b-table-column>-->
        <!--        <b-table-column field="speed" label="Speed (Lead/Follow)">
                  <template v-slot:header="{ column }">
                    <table-header :column="column" header-type="search" tooltip="Filter Speed" element-id="4786686884336"
                                  :table-header-data="tableHeaderData" @onSort="onSort"></table-header>
                  </template>
                  <template v-slot="props">
                    {{ props.row.speed }}
                  </template>
                </b-table-column>
                <b-table-column field="origin" label="Origin (A/B)">
                  <template v-slot:header="{ column }">
                    <table-header :column="column" header-type="search" tooltip="Filter Origin" element-id="477786884336"
                                  :table-header-data="tableHeaderData" @onSort="onSort"></table-header>
                  </template>
                  <template v-slot="props">
                    {{ props.row.origin }}
                  </template>
                </b-table-column>-->
        <b-table-column field="operator" label="Operator">
          <template v-slot:header="{ column }">
            <table-header :column="column" header-type="search" tooltip="Filter Operator" element-id="4775554336"
                          :table-header-data="tableHeaderData" @onSort="onSort"></table-header>
          </template>
          <template v-slot="props">
            {{ props.row.operator }}
          </template>
        </b-table-column>
      </b-table>
      <div v-else>No events</div>
    </div>
  </section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {
  coreIndicatorsOptions,
  getDate,
  getDateInTimeZone, getDateTime, getDateTimeInTimeZone,
  getRiskRatingClass, validationOptions,
} from "@/utils/utils";
import TableHeader from "@/components/table-header/table-header.vue";

export default {
  name: "validation-table",
  components: {TableHeader},
  props: {
    openNewPage: {
      type: Boolean,
      required: true
    },
    selectedVersion: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      checkedRows: [],
      selectedStatusChange: null,
      currentPage: 1,
      perPage: 5,
      dataVersion: 1
    }
  },
  mounted() {
    this.dataVersion = this.selectedVersion
    this.currentPage = this.pageNumber
  },
  methods: {
    ...mapActions({
      setTableHeaderData: 'dataValidationModule/setValidationTableHeaderData',
      selectEvent: 'dataValidationModule/selectEvent',
    }),
    cropId(id, front = 4, back = 4) {
      if (typeof id !== 'string') return '';
      return `${id.slice(0, front)}...${id.slice(-back)}`;
    },
    copyToClipboard(text) {
      if (!text) return;
      navigator.clipboard.writeText(text)
          .then(() => {
            this.showToast('Copied to clipboard', 'is-success')
          })
          .catch(err => {
            this.showToast('Failed to copy', 'is-danger')
          });
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    onVersionChanged(version) {
      this.$emit('onVersionChanged', version)
    },
    getClass(eventValid) {
      if (eventValid === 'unchecked') {
        return 'is-dark'
      } else if (eventValid === 'validated') {
        return 'is-primary'
      } else if (eventValid === 'incorrect') {
        return 'is-warning'
      } else if (eventValid === 'correct') {
        return 'is-info'
      } else if (eventValid === 'invalid') {
        return 'is-danger'
      } else {
        return 'is-dark'
      }
    },
    onUpdateSelectedItems() {
      console.log('On update selected items: ', this.checkedRows)
      let payload = {
        events: []
      }

      this.checkedRows.forEach(row => {
        let item = {
          eventId: row.id,
          eventValid: this.selectedStatusChange,
          updateSnippet: false
        }

        payload.events.push(item)
      })


      this.$emit('onUpdateConflictEvents', payload)

      setTimeout(() => {
        this.checkedRows = []
      }, 500)

      console.log('Payload: ', payload)
    },
    async loadEvent(event) {
      console.log('Event:', event)
      await this.selectEvent(event)
    },
    sortClicked(field, order) {
      console.log('Sorted: ', field, order)
      let tableHeaderData = this.tableHeaderData
      tableHeaderData.activeSorted = {field: field, order: order}
      this.setTableHeaderData(tableHeaderData)
    },
    onSort(tableHeaderData) {
      this.setTableHeaderData(tableHeaderData)
    },
    getDate(date) {
      return getDateInTimeZone(date, this.selectedDevice.timezone)
    },
    getTime(date) {
      return getDateTime(date, this.selectedDevice.timezone)
    },
    getRiskColor(risk) {
      return getRiskRatingClass(risk)
    },
    onPageChanged(pageNum) {
      console.log('On page changed', pageNum)
      //this.setTablePage(pageNum)
    },
  },
  computed: {
    coreIndicatorsOptions() {
      return coreIndicatorsOptions
    },
    validationOptions() {
      return validationOptions
    },
    ...mapGetters({
      validationTableData: 'dataValidationModule/getValidationTable',
      tableHeaderData: 'dataValidationModule/getValidationTableHeaderData',
      selectedDevice: 'dataValidationModule/getSelectedValidationDevice',
      selectedEvent: 'dataValidationModule/getSelectedEvent',
    }),
  },
  watch: {
    pageNumber() {
      if (this.pageNumber !== this.currentPage) {
        this.currentPage = this.pageNumber
      }
    },
    selectedVersion() {
      this.dataVersion = this.selectedVersion
    }
  }
}
</script>

<style scoped>

</style>